import axios from './axiosInstance';

const ItemGroupService = {
  async addItems(groupId, items) {
    const response = await axios.post(`/item-groups/${groupId}/items`, items);
    return response.data;
  },
  async updateItems(groupId, items) {
    const response = await axios.put(`/item-groups/${groupId}/items`, items);
    return response.data;
  },
  async deleteItems(groupId, ids) {
    const response = await axios.delete(`/item-groups/${groupId}/items`, {
      data: ids,
    });
    return response.data;
  },
};

export default ItemGroupService;
